import Vue from "vue";
window.Event = Vue.prototype.$bus = new Vue();
